import React from 'react';
import Hero from '../components/Hero/Hero';
import FounderBio from '../components/FounderBio/FounderBio';
import TrustBanner from '../components/TrustBanner/TrustBanner';
import References from '../components/References/References';
import Packages from '../components/Packages/Packages';
import SocialStats from '../components/SocialStats/SocialStats';
import Team from '../components/Testimonials/Testimonials';
import Contact from '../components/Contact/Contact';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <FounderBio />
      <References />
      <TrustBanner />
      <Packages />
      <SocialStats />
      <Team />
      <Contact />
    </>
  );
};

export default Home;
